import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Note } from "@school-sales-ai/shared";
import { api } from "@/lib/api";

export function useLeadNotes(leadId: string) {
  return useQuery({
    queryKey: ["notes", leadId],
    queryFn: () =>
      api.get<{ notes: Note[] }>(`/crm/leads/${leadId}/notes`),
    enabled: !!leadId,
  });
}

export function useCreateNote(leadId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (content: string) =>
      api.post<Note>(`/crm/leads/${leadId}/notes`, { content }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["notes", leadId] });
    },
  });
}
